import type { ReactNode } from 'react';
import { FeatureGate } from '../rbac/FeatureGate';
import { useIsSuperAdmin } from '../../hooks/useIsSuperAdmin';

/**
 * Route guard for the AI screens: the feature key, then an AIG email; anyone else sees "Coming soon".
 * `fallback` is what a user without the key sees (App.tsx passes SettingsDenied); without one, FeatureGate redirects.
 */
export function AiAreaRoute({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const isAig = useIsSuperAdmin();
  return (
    <FeatureGate featureKey="ai_lab" fallback={fallback}>
      {isAig ? (
        children
      ) : (
        <div className="p-6" data-testid="ai-area-coming-soon">
          <h1 className="text-2xl font-bold text-gray-900">Coming soon</h1>
          <p className="mt-2 text-gray-600">This part of Settings is not available yet.</p>
        </div>
      )}
    </FeatureGate>
  );
}
